import { gql } from 'graphql-request';

export const GET_THEME = gql`
  query getTheme($id: String!) {
    getTheme(id: $id) {
      colors {
        primary
        secondary
        button
        title
        icons
        selectedIcon
      }
      barColors {
        barA
        barAOpacity
        barB
        barBOpacity
        barC
        barCOpacity
        barD
        barDOpacity
      }

      pieColors {
        colorA
        colorB
        colorC
        colorD
        colorE
        colorF
        colorG
        colorH
        colorI
        colorJ
      }

      kpiColors {
        contribution
        contributionIcon
        distribution
        distributionIcon
        commitmentIcon
        commitment
        openCommitments
        openCommitmentsIcon
        transfer
        transferIcon
        custom1
        custom1Icon
        custom2
        custom2Icon
        custom3
        custom3Icon
        custom4
        custom4Icon
        custom5
        custom5Icon
      }

      kpiNames {
        contribution
        distribution
        commitment
        openCommitments
        transfer
        investedCapital
        accumulatedInterest
        equityPercentage
        category
      }

      categoryColors {
        colors {
          key
          value
        }
      }

      fonts {
        boldFont
        mainFont
      }
    }
  }
`;
